import type { AdminRole } from '@/lib/api-admin';

export type { AdminRole };

export interface AdminAccountSummary {
  adminUserId: string;
  loginId: string;
  email: string;
  name: string;
  roles: AdminRole[];
  twoFactorEnabled: boolean;
  status: string;
  lastLoginAt: string | null;
  createdAt: string;
}

export interface AdminAccountDetail extends AdminAccountSummary {
  passwordChangedAt: string | null;
  updatedAt: string;
}

export interface AdminAccountCreateRequest {
  loginId: string;
  email: string;
  name: string;
  password: string;
  roles: AdminRole[];
}

export interface AdminAccountUpdateRequest {
  email?: string;
  name?: string;
}

export interface AdminRolesReplaceRequest {
  roles: AdminRole[];
}

export interface AdminRoleView {
  code: string;
  mandatoryTwoFactor: boolean;
}

export interface AdminAccountListQuery {
  keyword?: string | undefined;
  role?: AdminRole | null | undefined;
  status?: string | null | undefined;
  page: number;
  size: number;
}

export interface AdminAccountListPage {
  items: ReadonlyArray<AdminAccountSummary>;
  meta: { page: number; size: number; totalItems: number; totalPages: number };
}

export const ADMIN_ROLE_CODES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'CS_AGENT',
  'MD_MANAGER',
  'FULFILLMENT_AGENT',
  'PICKUP_AGENT',
  'SETTLEMENT_AGENT',
  'AUDITOR',
];

/**
 * 화면에서 숨기는 역할 — 계정 생성 역할 선택·관리자 목록·권한 목록·[역할 권한 관리] 탭이 모두 이 목록을 쓴다(QA-514 후속,
 * 운영 결정: 최고 관리자·운영 관리자·고객 상담 3개만 운영). BE 는 8개 모두 지원하므로 여기서 빼면 바로 쓸 수 있다.
 */
const HIDDEN_ROLE_CODES = new Set<string>([
  'MD_MANAGER',
  'FULFILLMENT_AGENT',
  'PICKUP_AGENT',
  'SETTLEMENT_AGENT',
  'AUDITOR',
]);

export const isDisplayableRole = (code: string): boolean => !HIDDEN_ROLE_CODES.has(code);

export const visibleAdminRoleCodes: ReadonlyArray<AdminRole> = ADMIN_ROLE_CODES.filter((code) =>
  isDisplayableRole(code),
);
